<template>
  <div class="occupationPage" id="tinyScreenOccupation">
    <Header></Header>
    <!-- banner -->
    <div class="bannerBox" :style="{backgroundImage:'url('+pcAdvertUrl+')'}">
      <div class="container">
        <div class="storyTxt">
          <span class="bannerTxt">{{$t('occupation.bannerTxt')}}</span>
         <!--  <img width="731px" class="pcShow" src="../../assets/picture/occupation/index1.png">
          <img width="218px" class="phoneShow" src="../../assets/picture/occupation/phone/index1.png"> -->
          <span class="viewPost" @click="goList">{{$t('occupation.findJod')}}</span>
        </div>
      </div>
    </div>
    <!-- section1 -->
    <div class="section1 middle">
      <div class="container">
        <div class="title">
          {{$t('occupation.openPosition')}}
        </div>
        <ul class="pcShow">
          <li class="part" v-for="(item,index) in liList" :key="index" :style="{backgroundImage:'url('+item.thumbnail+')'}" >
            <div class="txt"  @click="goDetail(item,item.id)">
              <p>{{lang == 'cn'?item.typeName:item.typeEnName}}</p>
              <span>
                {{$t('occupation.more')}}
                <i><img width="10px" src="../../assets/picture/occupation/right.png"></i>
              </span>
            </div>
          </li>
        </ul>
        <div class="phoneShow">
          <el-carousel height="400px" class="phoneShow">
            <el-carousel-item v-for="(item,index) in  liList" :key="index">
              <div class="part" :style="{backgroundImage:'url('+item.thumbnail+')'}">
                <div class="txt" @click="goDetail(item,item.id)">
              <p>{{lang == 'cn'?item.typeName:item.typeEnName}}</p>
              <span>
                {{$t('occupation.more')}}
                <img width="10px" height="10px" src="../../assets/picture/occupation/right.png">
              </span>
            </div>
              </div>             
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <!-- section4 -->
    <div class="section4 middle">
      <div class="container">
        <div class="title">
          {{$t('occupation.schoolTxt')}}
        </div>
        <ul>
          <li>
            <img class="conPic" width="90px" src="../../assets/picture/occupation/t4.png">
            <p class="txt">{{$t('occupation.school')}}</p>
            <p class="subTitle">{{$t('occupation.schoolSub')}}</p>
            <div class="more" @click="goSchool">
              <span>{{$t('occupation.more')}}</span>
              <i><img width="10px" src="../../assets/picture/occupation/right.png"></i>
            </div>
          </li>
          <li>
            <img class="conPic" width="90px" src="../../assets/picture/occupation/t5.png">
            <p class="txt">{{$t('occupation.winnerCap')}}</p>
            <p class="subTitle">{{$t('occupation.winnerCapSub')}}</p>
            <div class="more" @click="goWinnter">
              <span>{{$t('occupation.more')}}555</span>
              <i><img width="10px" src="../../assets/picture/occupation/right.png"></i>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!-- section3 -->
    <div class="section3  middle">
      <div class="container" @click="goInterviewtipsPage">
        <img height="55px" class="mt137 mb30" src="../../assets/picture/occupation/winner2.png">
        <!-- <span>{{$t('occupation.jiayouzhan')}}</span> -->
        <img height="48px" class="mb30 sub" src="../../assets/picture/occupation/winner3.png">
      </div>
    </div>
   <!-- section2 -->
    <Code></Code>
    <!-- footer -->
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '../common/header';
import Footer from '../common/footer';
import Code from '../common/code';
export default {
  data() {
    return {
      liIndex:-1,
      isShowSearch:false,
      liList:[],
      lang:'',
      pcAdvertUrl:'',
      mobileAdvertUrl:'',
    };
  },
  components: { Header,Footer,Code },
  created(){
    this.lang = window.sessionStorage.getItem("language")?window.sessionStorage.getItem("language"):'cn';
  },
  mounted(){
    this.getAllJobType();
    this.getAdvert();
  },
  methods: {
       // 获取所有岗位分类
    async getAllJobType() {
        const { data: res } = await this.$http.get("/job/getAllJobType.do");
        if (res.code !== 200) return this.$message.error(res.message);
        this.liList = res.data;
      },
    goList(){
      this.$router.push({  
            path: '/positions'  
        }) 
    },
    goDetail(item,id){
      let lang = window.sessionStorage.getItem("language")?window.sessionStorage.getItem("language"):'cn';
      let title = '';
      if(lang == 'cn'){
        title = item.typeName;
      }else{
        title = item.typeEnName;
      }
      this.$router.push({  
            path: '/positions',
            query:{title:title,id:id,type:'init'}
        }) 
    },
    showSearch(){
      this.isShowSearch = !this.isShowSearch;
    },
     goSchool(){
      this.$router.push({  
            path: '/campus2022'  
        }) 
    },
    goInterviewtipsPage(){
      this.$router.push({  
            path: '/interviewtips'  
        }) 
    },
    goWinnter(){
      let url = 'https://mp.weixin.qq.com/s/qgk2HzH_y_Iv5-xFUkwfQw';
      window.location.href = url;
    },
    // 根据埋点ID及非必填项获取广告位
    async getAdvert() {
        const { data: res } = await this.$http.get("/advert/getAdvert.do?pointId=5");
        // 提示message
        if (res.code !== 200) return this.$message.error(res.message);
        this.pcAdvertUrl = res.data[0].pcAdvertUrl;
        this.mobileAdvertUrl = res.data[0].mobileAdvertUrl;
    },
  }
};
</script>

<style lang="less" scoped>
.occupationPage{
  .bannerBox{    
    width: 100%;
    height: 620px;
    background: url(../../assets/picture/occupation/p10.png) no-repeat;
    background-size: cover;
    background-position: center center;
    display: flex;
    .storyTxt{
       img{
        clear: both;
        display: block;
        margin: auto;
        margin-top: 238px;
       }
       .bannerTxt{
        font-size: 50px;
        font-weight: 100;
        text-align: center;
        color:#fff;
        margin:0 auto;
        display: block;
        padding-top: 185px;
        letter-spacing: 4px;
       }
       .viewPost{
        width: 180px;
        height: 44px;
        border: 2px solid #F2F2F2; 
        line-height: 44px;
        text-align: center;
        display: block;
        color:#F2F2F2;
        margin:0 auto;
        margin-top: 101px;
        cursor: pointer;
       }
    }
  }
  /*********************************************/
  .section1{
    padding:120px 0 112px 0;
    padding-top: 70px;
    .title{      
      font-size: 30px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 200px;
      color: #900211;
      line-height: 42px;
      margin-bottom: 50px;
    }
    ul{
      display: flex;
      li{
        margin-right: 24px;
        height: 380px;
        width: 100%;
        background-size: cover;
        cursor: pointer;
        .txt{
          margin:22px;
          font-size: 26px;
          font-family: PingFangSC-Light, PingFang SC;
          font-weight: 300;
          color: #F2F2F2;
          line-height: 37px;
          span{
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #F2F2F2;
            line-height: 20px;
          }
        }
      }
      li:last-of-type{
        margin-right: 0;
      }
    }
  }
  /*************************************************/
  .section3{
    width: 100%;
    height: 400px;
    background-image: url(../../assets/picture/occupation/weinner4.png);
    background-position: center center;
    background-size: cover;
    cursor: pointer;
    span{
      margin:0 auto;
      display: block;
      margin-top: 100px;
      color:#fff;
      text-align: center;
      font-size: 80px;
      margin-bottom: 20px;
      font-size: 100;
    }
    img{
      display: block;
      margin:0 auto;
    }
  }
 /****************************************************/
.section4{
   padding:0 0 112px 0;
    .title{      
      font-size: 30px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #900211;
      line-height: 42px;
      margin-bottom: 50px;
    }
    ul{
      display: flex;
      li{
        width: 100%;
        margin-right:24px;
        height: 320px; 
        background: #900211;
        .conPic{
          margin:30px;
          margin-bottom: 0;
        }
        .txt{
          margin:20px 0 10px 30px;
          font-size: 26px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #F2F2F2;
          line-height: 37px;
        }
        .subTitle{
          margin-bottom: 20px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #F2F2F2;
          line-height: 20px;
          letter-spacing: 1px;
          margin-left: 30px;
        }
        .more{
          margin-left: 30px;
          padding: 0px 20px;
          display: inline-block;
          height: 44px;
          border: 1px solid #F2F2F2;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #F2F2F2;
          line-height: 44px;
          padding-left: 26px;
          cursor: pointer;
        }
      }
    }
}
}
</style>
